import { render } from "./CxListItem.vue?vue&type=template&id=36eb3c2c"
import script from "./CxListItem.vue?vue&type=script&lang=js"
export * from "./CxListItem.vue?vue&type=script&lang=js"

import "./CxListItem.vue?vue&type=style&index=0&id=36eb3c2c&lang=less"

import exportComponent from "/home/ec2-user/workspace/_ui2_staging_ui2-staging-0.124.0/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__